import { api } from "@/lib/api/client"
import type { BaseResponse } from "@/types/api"
import type { Cooperative, ExporterKpis } from "@/types/domain"

export async function listCooperatives(): Promise<Cooperative[]> {
  const { data } = await api.get<BaseResponse<Cooperative[]>>(
    "/exporter/cooperatives"
  )
  if (!data.success) {
    throw new Error(data.message ?? "Could not load cooperatives")
  }
  return data.result ?? []
}

export async function getCooperative(
  cooperativeId: string
): Promise<Cooperative> {
  const { data } = await api.get<BaseResponse<Cooperative>>(
    `/exporter/cooperatives/${cooperativeId}`
  )
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not load cooperative")
  }
  return data.result
}

export async function getCooperativeKpis(
  groupId: number | string
): Promise<ExporterKpis> {
  const { data } = await api.get<BaseResponse<ExporterKpis>>("/exporter/kpis", {
    params: { groupId },
  })
  if (!data.success || !data.result) {
    throw new Error(data.message ?? "Could not load KPIs")
  }
  return data.result
}
